const RETAILERS_SORT_ORDERS = {
  DEFAULT: '',
  ASC: 'asc',
  DESC: 'desc',
};

export default RETAILERS_SORT_ORDERS;
